var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHangingLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 211 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.04 18.5h19.35c-.13-4.23-4.22-7.15-12.31-8.32-4.91-.72-9.94-1.12-14.91-1.14h-.71c-10.96.04-21.59 1.98-29.93 6.59-9.7 5.37-10.44 13.49-.78 17.45 8.13 3.32 25.2 3.66 37.42 1.59 7.92-1.35 13.96-3.95 17.36-7.83h-19.76c-2.56 1.96-5.9 2.95-9.81 2.98-11.09.08-12.55-3.28-10.61-7.15 2.3-4.55 7.12-7.03 14.48-7.23 5.78-.16 8.65 1.12 10.21 3.06M179.27 9.94l-8.6 19.15h29.04l-2.7 6h-49.95l11.25-25.15h20.96M11.29 35.11h20.45l4.38-10.04h20.04l-4.5 10.04h20.69L83.7 9.95H62.86l-3.74 8.48H39.1l3.79-8.48-20.24-.01-11.36 25.17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangingLogo);
export default __webpack_public_path__ + "static/media/hanging-logo.6c3e49a69c59688d54976716552aca16.svg";
export { ForwardRef as ReactComponent };